import axios from "axios";
import { environment } from "../../environment";

class ContentService {

    async get(id: string) {
        try {
            const path = environment.contentUrl + 'items/page/' + id;
            const res: any = await axios.get(path);
            if (res?.data)
                return res.data;
            else throw new Error('No CI was found')
        } catch (err) {
            throw err;
        }
    }
}

export default new ContentService() as ContentService;